import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Button,
  Icon,
} from '@resy/ui-kitchen';
import EventsSearchPillMenu from '../EventsSearchPillMenu';
import './EventsSearchPill.scss';
import { CITY_FILTER, FILTER_EVENTS } from '../../ExperientialEvents';

const EventsSearchPill = (props) => {
  const {
    isOpen,
    onLocationSelect,
    onToggle,
    loading,
    typeOfFilter,
    filterData,
    onFilterSelect,
    selectedFilterValues,
    numberOfFilter,
    onClickFilterEvents,
  } = props;

  let buttonLabel = '';
  let searchAriaLabel = '';
  let dataToDisplay = null;

  if (typeOfFilter === CITY_FILTER) {
    dataToDisplay = filterData?.filter((labelItem) => labelItem.type === 'cities')[0]?.data;
    dataToDisplay?.push({ code: 'ALL', name: 'All Cities' });
    buttonLabel = 'All Cities';
    searchAriaLabel = 'Search Location. Selected location is All Cities';

    if (selectedFilterValues?.name) {
      buttonLabel = selectedFilterValues?.name;
      searchAriaLabel = `Search Location. Selected location is ${selectedFilterValues?.name}`;
    }
  } else if (typeOfFilter === FILTER_EVENTS) {
    dataToDisplay = filterData?.slice(0);
    buttonLabel = 'Filter Events';
    searchAriaLabel = 'Search Events. And Selected events';
  }

  return (
    <div
      className={cx('EventsSearchPill', {
        'EventsSearchPill--open': isOpen,
      })}
    >
      <div className="Selector">
        <Button
          className={cx('AmexExperientialEventsFilter__citypanel__button EventsSearchPill__click-container', {
            'EventsSearchPill__click-container--open': isOpen,
          })}
          {...loading ? { disabled: true } : ''}
          onClick={onToggle}
          variant="no-style"
          aria-expanded={isOpen}
          aria-label={searchAriaLabel}
        >
          <span>{buttonLabel}</span>
          {(typeOfFilter === CITY_FILTER) && <Icon name="MagnifyingGlass" />}
          {numberOfFilter === 0 && (typeOfFilter === FILTER_EVENTS) && <Icon name="AmexFilter" />}
          {numberOfFilter > 0 && (<i className="circle"><span className="number">{numberOfFilter}</span></i>)}
        </Button>

        <EventsSearchPillMenu
          isOpen={isOpen}
          locations={dataToDisplay}
          onLocationSelect={onLocationSelect}
          onClose={onToggle}
          typeOfFilter={typeOfFilter}
          onFilterSelect={onFilterSelect}
          selectedFilterValues={selectedFilterValues}
          onClickFilterEvents={onClickFilterEvents}
        />
      </div>
    </div>
  );
};

EventsSearchPill.propTypes = {
  Analytics: PropTypes.shape({}).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onLocationSelect: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  selectedLocation: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  typeOfFilter: PropTypes.string.isRequired,
  filterData: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(),
  }).isRequired).isRequired,
  numberOfFilter: PropTypes.number.isRequired,
  onFilterSelect: PropTypes.func.isRequired,
  selectedFilterValues: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  onClickFilterEvents: PropTypes.func.isRequired,
};

EventsSearchPill.displayName = 'EventsSearchPill';

export default EventsSearchPill;
